import type { Nullable } from 'primereact/ts-helpers';

export function goToViewCarrier(carrierId: Nullable<number>) {
  if (!carrierId) return '';
  return `/main/carriers/${carrierId}/view`;
}

export function goToViewCarrier_customer(
  carrierGuid: Nullable<string>,
  guid: Nullable<string>,
) {
  if (!carrierGuid) return '';
  return `/main/${guid}/carriers/${carrierGuid}/view`;
}

export function goToEditCarrier(
  carrierId: Nullable<number>,
  tabIndex?: number,
) {
  if (!carrierId) return '';
  return `/main/carriers/${carrierId}/edit${tabIndex ? `?t=${tabIndex}` : ''}`;
}

export function goToAddCarrier() {
  return '/main/carriers/add';
}
